import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  '@global': {
    img: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  primaryColor: {
    color: '#7833FF',
  },
  lightBg: {
    backgroundColor: '#f1f1f1',
  },
  darkBg: {
    backgroundColor: '#212121',
  },
  verticalDivider: {
    backgroundColor: theme.palette.grey[50],
    margin: theme.spacing(3, 3, 0, 3),
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: '#7833FF',
    borderRadius: 40,
  },
  sectionImage: {
    display: 'block',
    margin: '0 auto',
    width: 600,
  },
  stepSection: {
    padding: theme.spacing(4, 0),
    color: theme.palette.common.white,
    backgroundColor: '#311171',

    '& h6': {
      marginBottom: theme.spacing(4),
      textAlign: 'center',
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  stepper: {
    backgroundColor: 'transparent',
    maxWidth: 500,
    margin: '0 auto',

    [theme.breakpoints.up('md')]: {
      maxWidth: 'auto',
      margin: 0,
    },
  },
  stepLabel: {
    color: `${theme.palette.common.white} !important`,
    fontSize: theme.typography.body1.fontSize,
  },
  stepLabelActive: {
    fontWeight: `${theme.typography.fontWeightBold} !important`,
  },
  stepIcon: {
    display: 'inline-block',
    width: 25,
    height: 25,
    color: '#5F29CC',
    backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    lineHeight: '1.5em',
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightBold,
  },
  stepIconActive: {
    color: '#55A30B',
  },
  stepIconCompleted: {
    color: theme.palette.common.white,
    backgroundColor: '#55A30B',
  },
  stepVideo: {
    maxWidth: '100%',
    borderRadius: theme.shape.borderRadius,
  },
  avatarItem: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  avatarBox: {
    display: 'inline-flex',
    alignItems: 'center',
    textAlign: 'left',

    '& img': {
      maxWidth: 100,
      border: '2px solid #7555B8',
      borderRadius: '50%',
    },

    '& ul': {
      margin: 0,
      paddingLeft: 0,
      listStylePosition: 'inside',
      lineHeight: theme.typography.h6.lineHeight,
    },
  },
  avatarBoxText: {
    marginLeft: theme.spacing(3),
    color: '#7555B8',
  },
  title1: {
    marginBottom: theme.spacing(6),
    textAlign: 'center',
    color: '#7833FF',
    fontWeight: theme.typography.fontWeightBold,
  },
  title2: {
    color: '#7833FF',
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(6),
  },
  infoBox: {
    backgroundColor: '#4A2A8B',
    borderRadius: 10,
  },
  infoBoxContent: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(6),

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'start',
      backgroundSize: 230,
    },
  },
  infoBoxItem: {
    flex: 1,
    marginBottom: 20,

    '& p': {
      color: theme.palette.common.white,
    },

    '& a': {
      display: 'inline-block',
      marginTop: theme.spacing(4),
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold,

      '&:hover': {
        textDecoration: 'none',
      },

      '& svg': {
        position: 'relative',
        top: 7.5,
      },
    },
  },
  infoBoxIcon: {
    maxWidth: 65,
    marginBottom: theme.spacing(1),
  },
  infoBoxText: {
    marginTop: theme.spacing(8.75),
  },
  partnerLogo: {
    padding: theme.spacing(3, 0),
    color: theme.palette.common.white,
    textAlign: 'center',
    borderBottom: '1px solid rgba(255, 255, 255, .15)',

    '& img': {
      verticalAlign: 'top',
      filter: 'brightness(1000%)',
    },
  },
  showMeHow: {
    fontSize: 23,
  },
  buttonImage: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));
